'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _ramda = require('ramda');
var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _reduxForm = require('redux-form');

var _components = require('../../components');

var _reduxFormValidators = require('../../helpers/reduxFormValidators');
var _formatPhoneNumber = require('../../utils/formatPhoneNumber');
var _validate = require('../../utils/validate');



var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);
var _userAuthentication = require('../../redux/modules/userAuthentication');






var _constants = require('../../constants');
var _messageModal = require('../../redux/modules/messageModal');
var _UserAuthentication = require('../UserAuthentication/UserAuthentication.scss');var styles = _interopRequireWildcard(_UserAuthentication);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Helpers
var PublishAuthenticationContainer = function (_Component) {_inherits(PublishAuthenticationContainer, _Component);function PublishAuthenticationContainer() {var _temp, _this, _ret;_classCallCheck(this, PublishAuthenticationContainer);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      sending: false,
      successfully: null,
      emailIsChecked: false,
      phoneIsChecked: false,
      emailIsExist: null,
      isForgotPassword: false,
      emailIsValid: false,
      phoneIsValid: false,
      isEmailOfAgent: null,
      captcha: null,
      error: null }, _this.


























    getAuthErrorMessage = function () {
      if (!_this.props.authError || !_this.state.emailIsChecked) {
        return null;
      }

      var type = _this.state.emailIsExist ? 'signInTab' : 'newAccountTab';
      type = _this.state.isForgotPassword ? 'forgotPassword' : type;

      return _this.props.translate('userAuthentication', type, 'errorMessage').toString();
    }, _this.

    checkIfNeedChangeUserType = function () {var
      isAgent = _this.props.isAgent;var _this$state =
      _this.state,emailIsChecked = _this$state.emailIsChecked,emailIsExist = _this$state.emailIsExist,isEmailOfAgent = _this$state.isEmailOfAgent;

      return emailIsChecked && emailIsExist && isAgent && isEmailOfAgent === false;
    }, _this.
    fetchReCaptchaToken = function (token) {
      _this.setState({ captcha: token });
    }, _this.
    checkPhone = function (phone) {var
      locale = _this.props.locale;var
      captcha = _this.state.captcha;
      _this.setState({ sending: true });

      _axios2.default.post('users/login-phone', {
        captcha: captcha,
        phone: (0, _formatPhoneNumber.authenticationFormatPhoneNumber)(phone),
        locale: locale }).

      then(function () {
        _this.setState({
          sending: false,
          captcha: null,
          phoneIsChecked: true,
          phoneNumberNotVerified: null });

      }).
      catch(function () {return _this.setState({
          sending: false,
          captcha: null,
          phoneIsChecked: false,
          phoneNumberNotVerified: _this.props.translate('publishAuthentication', 'phoneNumberNotVerified').toString() });});

    }, _this.

    checkEmail = function (emailData) {
      _this.setState({ sending: true });
      _axios2.default.post('users/email/is_exist', { email: emailData }).
      then(function (_ref) {var data = _ref.data;
        _this.setState({
          emailIsChecked: true,
          emailIsExist: data.result,
          isEmailOfAgent: data.result ? data.is_agent : null,
          sending: false });

      }).
      catch(function () {return _this.setState({
          emailIsChecked: false,
          sending: false,
          isEmailOfAgent: null,
          error: _this.props.translate('publishAuthentication', 'errorMessage').toString() });});

    }, _this.
    emailValidate = function (value) {
      var trimmedValue = value ? value.replace(/\s/g, '') : '';

      var emailIsValid = (0, _validate.emailRegexValidation)(trimmedValue);
      var phoneIsValid = (0, _validate.phoneRegexValidation)(trimmedValue);

      _this.setState({
        emailIsValid: emailIsValid,
        phoneIsValid: phoneIsValid });


      if (phoneIsValid) {
        return (0, _reduxFormValidators.phoneNumber)(value);
      }

      return (0, _reduxFormValidators.email)(value);
    }, _this.
    submitForm = function (values) {
      _this.setState({ error: null, phoneNumberNotVerified: null });

      _this.props.clearAuthError();

      if (_this.state.emailIsValid && !_this.state.emailIsChecked) {
        return _this.checkEmail(values.email);
      }

      if (_this.state.phoneIsValid && !_this.state.phoneIsChecked) {
        return _this.checkPhone(values.email);
      }

      if (_this.state.isForgotPassword) {
        return _this.props.sendEmail({ email: values.email, locale: _this.props.locale });
      }

      if (_this.state.phoneIsChecked) {
        _this.setState({ sending: true });
        return _this.props.authenticateUserByNumber({
          phone: (0, _formatPhoneNumber.authenticationFormatPhoneNumber)(values.email),
          code: values.numberCode,
          captcha: _this.state.captcha }).
        then(_this.setState({ captcha: null, sending: false }));
      }

      if (_this.checkIfNeedChangeUserType()) {
        return _this.props.loginWithEdit(Object.assign({},
        values, {
          is_agent: _this.props.isAgent }));

      }

      return _this.props.authenticateUser(Object.assign({},
      values, {
        is_agent: _this.props.isAgent,
        requestType: _this.state.emailIsExist ?
        _constants.userAuthenticationTabs.SIGN_IN :
        _constants.userAuthenticationTabs.NEW_ACCOUNT }));

    }, _this.

    handleEmailChange = function (event, newValue, previousValue, name) {
      if (
      event &&
      event.nativeEvent &&
      typeof event.nativeEvent.inputType === 'undefined' &&
      newValue === '')
      {
        return;
      }

      if (newValue.length === 0) {
        _this.setState({
          emailIsValid: false,
          phoneIsValid: false,
          emailIsChecked: false,
          phoneIsChecked: false,
          emailIsExist: null,
          isEmailOfAgent: null });

      }

      if (newValue !== previousValue && previousValue !== undefined && !_this.state.isForgotPassword) {
        _this.props.reset();
        _this.setState({
          emailIsChecked: false,
          emailIsExist: null,
          isEmailOfAgent: null,
          phoneIsChecked: false });

      }

      _this.props.change(name, newValue);
    }, _this.

    toggleForgotPassword = function (evt) {
      evt.preventDefault();
      _this.props.clearAuthError();
      _this.setState({ isForgotPassword: !_this.state.isForgotPassword });
    }, _temp), _possibleConstructorReturn(_this, _ret);}PublishAuthenticationContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {if (nextProps.errorPhoneCode !== this.props.errorPhoneCode && nextProps.errorPhoneCode) {this.setState({ phoneNumberNotVerified: this.props.translate('publishAuthentication', 'incorrectCode').toString() });}if (nextProps.recoveryEmailWasSent && !this.props.recoveryEmailWasSent) {this.setState({ isForgotPassword: false });this.props.openMessageModal({ message: _react2.default.createElement('div', { className: 'successMessage' }, _react2.default.createElement('div', { className: styles.noTitleContent }, this.props.translate('userAuthentication', 'emailSent', 'description'))) });}if (nextProps.authError && nextProps.authError.message) {this.setState({ error: nextProps.authError.message });}};PublishAuthenticationContainer.prototype.


  render = function render() {var _props =
    this.props,translate = _props.translate,isAgent = _props.isAgent,isMobile = _props.isMobile,isRtl = _props.isRtl,locale = _props.locale,authError = _props.authError;var _state =









    this.state,emailIsChecked = _state.emailIsChecked,emailIsExist = _state.emailIsExist,sending = _state.sending,isForgotPassword = _state.isForgotPassword,error = _state.error,phoneIsChecked = _state.phoneIsChecked,emailIsValid = _state.emailIsValid,phoneIsValid = _state.phoneIsValid;

    return (
      _react2.default.createElement(_components.PublishAuthentication, {
        handleSubmit: this.props.handleSubmit(this.submitForm),
        socialNetworkAuthentication: this.props.socialNetworkAuthentication,
        isAgent: isAgent,
        isMobile: isMobile,
        isRtl: isRtl,
        locale: locale,
        emailIsChecked: emailIsChecked,
        phoneIsChecked: phoneIsChecked,
        emailIsExist: emailIsExist,
        sending: sending,
        isForgotPassword: isForgotPassword,
        translate: translate('publishAuthentication'),
        rootTranslate: translate,
        toggleForgotPassword: this.toggleForgotPassword,
        handleEmailChange: this.handleEmailChange,
        error: error || this.getAuthErrorMessage(),
        shouldChangeUserType: this.checkIfNeedChangeUserType(),
        emailValidate: this.emailValidate,
        fetchReCaptchaToken: this.fetchReCaptchaToken,
        captcha: this.state.captcha,
        phoneNumberNotVerified: this.state.phoneNumberNotVerified,
        emailIsValid: emailIsValid,
        phoneIsValid: phoneIsValid }));


  };return PublishAuthenticationContainer;}(_react.Component);


PublishAuthenticationContainer.propTypes = {
  isAgent: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  reset: _propTypes2.default.func,
  change: _propTypes2.default.func,
  handleSubmit: _propTypes2.default.func,
  authenticateUser: _propTypes2.default.func,
  authenticateUserByNumber: _propTypes2.default.func,
  socialNetworkAuthentication: _propTypes2.default.func,
  loginWithEdit: _propTypes2.default.func,
  sendEmail: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  errorPhoneCode: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  recoveryEmailWasSent: _propTypes2.default.bool,
  authError: _propTypes2.default.object,
  clearAuthError: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func };



var mapStateToProps = function mapStateToProps(state) {return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    locale: state.lang.locale,
    isMobile: state.windowDimentions.isMobile,
    isRtl: (0, _checkRtlLanguage2.default)(state.lang.locale),
    authError: state.userAuthentication.error,
    recoveryEmailWasSent: state.userAuthentication.emailSent,
    errorPhoneCode: state.userAuthentication.errorPhoneCode };};exports.default =


(0, _ramda.compose)(
(0, _reactRedux.connect)(mapStateToProps, {
  authenticateUser: _userAuthentication.authenticateUser,
  socialNetworkAuthentication: _userAuthentication.socialNetworkAuthentication,
  authenticateUserByNumber: _userAuthentication.authenticateUserByNumber,
  loginWithEdit: _userAuthentication.loginWithEdit,
  sendEmail: _userAuthentication.sendEmail,
  clearAuthError: _userAuthentication.clearAuthError,
  openMessageModal: _messageModal.openMessageModal }),

(0, _reduxForm.reduxForm)({
  form: 'publishAuthenticationForm' }))(

PublishAuthenticationContainer);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PublishAuthenticationContainer/PublishAuthenticationContainer.js
// module id = 3017
// module chunks = 0